import { gtmFormSubmit } from "~/utils/gtm";

// Elfsight's negotiate/inquiry form widget is a third-party embed we don't control the
// DOM of, so we can't attach a normal submit handler to it. On a successful submission it
// POSTs to this endpoint and responds { status: "success" } — confirmed via network
// inspection — so we detect the event by watching for that response instead.
const ELFSIGHT_FORM_SUBMIT_URL = "data.elfsight.com/public/resources/form-submissions";

export default defineNuxtPlugin(() => {
  window.dataLayer = window.dataLayer || []

  const route = useRoute();

  const notifyFormSubmitted = () => {
    gtmFormSubmit({
      form_name: "inquiry_form",
      experience_name: String(route.query.experience ?? ""),
      option_name: String(route.query.option ?? ""),
    });
  };

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = typeof args[0] === "string" ? args[0] : (args[0] as Request)?.url;

    if (url?.includes(ELFSIGHT_FORM_SUBMIT_URL)) {
      response
        .clone()
        .json()
        .then((data) => {
          if (data?.status === "success") notifyFormSubmitted();
        })
        .catch(() => {});
    }

    return response;
  };

  const originalXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method: string, url: string, ...rest: any[]) {
    if (typeof url === "string" && url.includes(ELFSIGHT_FORM_SUBMIT_URL)) {
      this.addEventListener("load", () => {
        try {
          const data = JSON.parse(this.responseText);
          if (data?.status === "success") notifyFormSubmitted();
        } catch {
          // non-JSON response, ignore
        }
      });
    }
    // @ts-expect-error - spreading through the native overload signature
    return originalXhrOpen.call(this, method, url, ...rest);
  };
})
